import React, { useMemo, useState } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

import User1 from "../../stuff/chop.jpeg";
import User2 from "../../stuff/suya.jpeg";
import User3 from "../../stuff/jollof.jpeg";
import User4 from "../../stuff/pepper.jpeg";

const PRIMARY = "#0c513f";
const ACCENT = "#ffbf07";
const CREAM = "#fdf7e9";

function Section6() {
  const reduceMotion = useReducedMotion();
  const [active, setActive] = useState(0);

  const slides = useMemo(
    () => [
      {
        img: User1,
        name: "Chop Chief",
        quote:
          "Hunger no dey wait — I let the app shuffle my chop and boom, I don find my chop! Even when money no dey, I still dey chop. Cheeee!",
      },
      {
        img: User2,
        name: "Suya Queen",
        quote:
          "Suya dey call me like mama dey call her pikin. I no dey waste time — I tap and my suya don line up, spicy and smoky as ever.",
      },
      {
        img: User3,
        name: "Jollof Jide",
        quote:
          "Jollof na the real champion! I open the app and every spoon dey burst my head. If you never try am, you dey miss.",
      },
      {
        img: User4,
        name: "Pepper King",
        quote:
          "I love my pepper but my wallet no dey gree heavy fees. I just dey tap the app for that fiery kick — service charge no even loud.",
      },
    ],
    []
  );

  const cardAnim = reduceMotion
    ? {}
    : {
        initial: { opacity: 0, y: 18, scale: 0.985 },
        animate: { opacity: 1, y: 0, scale: 1 },
        exit: { opacity: 0, y: -10, scale: 0.99 },
        transition: { duration: 0.5, ease: "easeOut" },
      };

  return (
    <section
      className="blog_section"
      style={{
        position: "relative",
        overflow: "hidden",
        padding: "80px 0",
        background: `linear-gradient(180deg, ${CREAM}, #ffffff)`,
        borderTop: "1px solid rgba(255,191,7,0.22)",
      }}
    >
      {/* subtle background blobs */}
      <div aria-hidden="true" style={{ position: "absolute", inset: 0 }}>
        <div
          style={{
            position: "absolute",
            top: "-180px",
            left: "-220px",
            width: 560,
            height: 560,
            borderRadius: 999,
            background: "rgba(255,191,7,0.18)",
            filter: "blur(80px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-220px",
            right: "-260px",
            width: 620,
            height: 620,
            borderRadius: 999,
            background: "rgba(12,81,63,0.10)",
            filter: "blur(90px)",
          }}
        />
      </div>

      <Container style={{ position: "relative", zIndex: 2 }}>
        <Row className="justify-content-center">
          <Col lg={9} xl={8}>
            {/* header */}
            <div style={{ textAlign: "center", marginBottom: 18 }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 14px",
                  borderRadius: 999,
                  background: "rgba(12,81,63,0.06)",
                  border: "1px solid rgba(12,81,63,0.10)",
                  marginBottom: 12,
                }}
              >
                <span
                  style={{
                    width: 9,
                    height: 9,
                    borderRadius: 999,
                    background: ACCENT,
                    boxShadow: "0 0 18px rgba(255,191,7,0.6)",
                  }}
                />
             
              </div>

              <h2
                style={{
                  margin: 0,
                  fontSize: "clamp(26px, 3vw, 38px)",
                  lineHeight: 1.1,
                  color: "#101010",
                  letterSpacing: "-0.3px",
                }}
              >
                What people are saying
              </h2>

              <p
                style={{
                  margin: "10px auto 0",
                  maxWidth: 620,
                  color: "rgba(16,16,16,0.62)",
                  fontFamily: "Kadwa",
                  fontSize: 14.5,
                  lineHeight: 1.8,
                }}
              >
                Short reviews from the “food lovers club” 
              </p>
            </div>

            {/* carousel */}
            <div
              style={{
                position: "relative",
                borderRadius: 26,
                background: "rgba(255,255,255,0.70)",
                border: "1px solid rgba(255,191,7,0.28)",
                boxShadow: "0 22px 70px rgba(0,0,0,0.10)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                overflow: "hidden",
                padding: "22px 16px 18px",
              }}
            >
              {/* accent bar */}
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 6,
                  background: `linear-gradient(90deg, ${ACCENT}, rgba(255,191,7,0.15), ${ACCENT})`,
                  opacity: 0.9,
                }}
              />

              {/* custom card renderer so caption isn't "jumbled" inside Carousel.Caption */}
              <Carousel
                activeIndex={active}
                onSelect={(selectedIndex) => setActive(selectedIndex)}
                indicators
                controls
                interval={5500}
                pause="hover"
                touch
                fade={false}
                style={{ paddingBottom: 14 }}
              >
                {slides.map((s, idx) => (
                  <Carousel.Item key={idx}>
                    <div style={{ minHeight: 240, padding: "10px 10px 0" }}>
                      <AnimatePresence mode="wait">
                        {active === idx && (
                          <motion.div key={idx} {...cardAnim}>
                            {/* top row */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 12,
                                marginBottom: 14,
                              }}
                            >
                              {/* avatar ring */}
                              <div
                                style={{
                                  width: 72,
                                  height: 72,
                                  borderRadius: 999,
                                  background: "rgba(255,191,7,0.22)",
                                  border: "1px solid rgba(255,191,7,0.35)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 14px 34px rgba(0,0,0,0.10)",
                                }}
                              >
                                <img
                                  src={s.img}
                                  alt={s.name}
                                  style={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: 999,
                                    objectFit: "cover",
                                    border: "2px solid #fff",
                                  }}
                                />
                              </div>

                              {/* name + stars */}
                              <div style={{ textAlign: "left" }}>
                                <div
                                  style={{
                                    fontWeight: 900,
                                    letterSpacing: "0.6px",
                                    color: "#101010",
                                    fontSize: 14,
                                  }}
                                >
                                  {s.name.toUpperCase()}
                                </div>

                                <div style={{ display: "flex", gap: 4, marginTop: 6 }}>
                                  {Array.from({ length: 5 }).map((_, i) => (
                                    <i key={i} className="bi bi-star-fill" style={{ color: ACCENT }} />
                                  ))}
                                </div>
                              </div>
                            </div>

                            {/* quote card */}
                            <div
                              style={{
                                position: "relative",
                                maxWidth: 760,
                                margin: "0 auto",
                                padding: "16px 16px",
                                borderRadius: 18,
                                background: "rgba(255,191,7,0.10)",
                                border: "1px solid rgba(255,191,7,0.28)",
                              }}
                            >
                              {/* quote marks */}
                              <div
                                aria-hidden="true"
                                style={{
                                  position: "absolute",
                                  top: -14,
                                  left: 14,
                                  width: 34,
                                  height: 34,
                                  borderRadius: 12,
                                  background: "#fff",
                                  border: "1px solid rgba(255,191,7,0.35)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: PRIMARY,
                                  fontWeight: 900,
                                  boxShadow: "0 12px 26px rgba(0,0,0,0.08)",
                                }}
                              >
                                “
                              </div>

                              <p
                                style={{
                                  margin: 0,
                                  fontFamily: "Kadwa",
                                  fontSize: 14.5,
                                  lineHeight: 1.9,
                                  color: "rgba(16,16,16,0.70)",
                                  textAlign: "center",
                                }}
                              >
                                {s.quote}
                              </p>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>

              {/* tiny dots hint */}
              <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 8 }}>
                {slides.map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: i === active ? 22 : 8,
                      height: 8,
                      borderRadius: 999,
                      background: i === active ? PRIMARY : "rgba(12,81,63,0.18)",
                      transition: "all 220ms ease",
                    }}
                  />
                ))}
              </div>
            </div>

            {/* little footer note */}
            <div style={{ textAlign: "center", marginTop: 12, color: "rgba(16,16,16,0.52)", fontSize: 12.5 }}>
              More reviews coming soon ✨
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Section6;
